<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("UPP Loyalty Logs") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row" style="zoom: 0.8">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                  v-validate="'required'"></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate" v-validate="'required'">
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <b-form-input type="text" v-model="searchInput" placeholder="Search Email/ Mobile No/ Booking Code" />
              <label :class="searchInput ? 'active' : ''">{{
                "Search Email/ Mobile No/ Booking Code"
              }}</label>
            </div>
          </div>

          <div class="col-1 align-self-center mb-3">
            <multiselect v-model="selectedTypeFilter" :placeholder="'Filter'" :options="fillterArray" label="name"
              track-by="id" :multiple="false" :showLabels="false" @select="onSelectFilterType($event, 'SELECT')"
              @remove="onSelectFilterType($event, 'REMOVE')"></multiselect>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="getLoyaltyLogs('N', 'N')">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>
      <div style="overflow-x: scroll; width: auto !important" ref="exportable_table">
        <table class="swc-report-table loyalty_logs" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th class="w-25">Customer Name</th>
            <th class="w-25">Customer Email</th>
            <th class="w-25">Customer Mobile</th>
            <th class="w-25">Booking Reference</th>
            <th class="w-50">Request</th>
            <th class="w-25">Upp Response</th>
            <th class="w-25">Remarks</th>
            <th class="w-25">Status</th>
            <th class="w-25">Action</th>
          </thead>
          <tbody v-if="uppRecords.length > 0">
            <tr v-for="(uppObj, uppIndex) in uppRecords" :key="uppIndex">
              <td class="text-left w-25">
                {{ uppObj.first_name }} {{ uppObj.last_name }}
              </td>
              <td class="text-left w-25" @dblclick="copyData(uppObj.cust_email)" :title="uppObj.cust_email">
                {{ uppObj.cust_email }}
              </td>
              <td class="text-left w-25" @dblclick="copyData(uppObj.cust_mobile)" :title="uppObj.cust_mobile">
                {{ uppObj.cust_mobile }}
              </td>
              <td class="text-left w-25" @dblclick="copyData(uppObj.booking_reference)"
                :title="uppObj.booking_reference">
                {{ uppObj.booking_reference }}
              </td>
              <td class="text-left w-50" @dblclick="copyData(uppObj.payload_data)" :title="uppObj.payload_data">
                {{ uppObj.payload_data }}
              </td>
              <td class="text-left w-25" @dblclick="copyData(uppObj.response_data)" :title="uppObj.response_data">
                {{ uppObj.response_data }}
              </td>
              <td class="text-left w-25">{{ uppObj.remarks }}</td>
              <td class="text-left w-25">{{ uppObj.ll_status }}</td>
              <td>
                <p class="text-left w-25" v-if="uppObj.ll_status == 'Y'">
                  Order submitted
                </p>
                <button class="btn-blue w-100" v-else @click="resendLogs(uppObj.ll_id, uppObj.payload_data)">
                  Resend
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination v-if="uppRecords.length > 0" v-model="currentPage" :per-page="perPage" :total-rows="rows"
        aria-controls="my-table" class="my-3" @change="onChangePagination($event)"></b-pagination>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      perPage: 50,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      typeFilter: "N",
      selectedTypeFilter: {
        id: 2,
        flag: "N",
        name: "Failed",
      },
      fillterArray: [
        {
          id: 1,
          flag: "Y",
          name: "Success",
        },
        {
          id: 2,
          flag: "N",
          name: "Failed",
        },
        {
          id: 3,
          flag: null,
          name: "All",
        },
      ],

      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      uppRecords: [],
      excelFilePath: "",
      searchInput: "",
      grandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() { },
  methods: {
    moment,
    copyData(copy_data) {
      navigator.clipboard.writeText(copy_data);
      this.$toasted.show("Text Copied");
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getLoyaltyLogs("N", "N");
      } else {
        this.currentPage = event;
        this.getLoyaltyLogs("N", "N");
      }
    },
    onSelectFilterType(event, type) {
      if (type == "REMOVE") {
        this.typeFilter = null;
      } else {
        this.typeFilter = event["flag"];
      }
      this.getLoyaltyLogs("N", "N");
    },
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
          wb,
          fn ||
          `RawMaterialSupplierWiseCost-${this.dropDown.selectedCinemaName
          }.${type || "xlsx"}`
        );
    },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getLoyaltyLogs(isExcel = "N", isPdf = "N") {
      this.uppRecords = [];

      let loader = this.$loading.show();
      let payload = {
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        searchQuery: this.searchInput,
        limit: this.perPage,
        currentPage: this.currentPage,
        filter: this.typeFilter,
      };
      ReportsService.GetUppLogs(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.uppRecords = [...data.Records];
            this.grandTotal = data.grandTotal;
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }

          if (data.totalRows && data.totalRows >= 10) {
            this.rows = data.totalRows;
            this.selectedvalue = this.perPage;
          } else if (data.totalRows) {
            this.rows = data.totalRows;
            this.selectedvalue = data.totalRows;
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
    resendLogs(log_id, request_data) {
      let loader = this.$loading.show();
      let payload = {
        ll_id: log_id,
        request_body: request_data,
      };
      ReportsService.ResendFailedUpp(payload)
        .then((response) => {
          const { data } = response;
          this.$toasted.show(data.message);
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style scoped>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.loyalty_logs .swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.loyalty_logs .swc-report-table td {
  white-space: nowrap;
  max-width: 195px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.loyalty_logs .swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.loyalty_logs .swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltyComponent/loyaltyLogs.vue